import { AfterViewInit, Component, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/index';
import { NotificationActions } from './state/notification.actions';
import { NotificationSelectors } from './state/notification.selectors';

type WebSocketPayload = string | ArrayBuffer | Blob; // This type is for some reason not exported by rxjs-websockets

// TODO: Consider adding headers, security token, etc.
interface WebSocketMessage {
    topic: string;
    body: any;
}

@Component({
    selector: 'top-navigation-two-way-unread-notification',
    template: `
      <div *ngIf="(unreadTwoWayMessages$ | async) as unreadTwoWayMessages"
           class="navbar-two-way-unread-messages-indicator">{{ unreadTwoWayMessages }}
      </div>
    `
})
export class TopNavigationTwoWayUnreadNotificationComponent implements AfterViewInit, OnDestroy {
    private subscription: Subscription = new Subscription();

    public unreadTwoWayMessages$: Observable<number>;

    // remoteMessages$: Observable<any>;

    constructor(
        private store: Store<any>,
        private unreadMessagesSelector: NotificationSelectors) {
        console.log('TopNavigationTwoWayUnreadNotificationComponent constructed');
        this.unreadTwoWayMessages$ = this.unreadMessagesSelector.selectUnreadMessages();
    }

    ngAfterViewInit(): void {
        console.log('TopNavigationTwoWayUnreadNotificationComponent requesting sync unread');
        this.store.dispatch(NotificationActions.startSyncUnreadTwoWayMessages());
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.store.dispatch(NotificationActions.stopSyncUnreadTwoWayMessages());
    }

}
